module.exports = __webpack_public_path__ + "img/ícone-seta-direita-cinza.cbd63c81.svg";